const STORAGE_KEY = 'gls.cookie-notice';
const RECORD_VERSION = 1;
const initializedBanners = new WeakSet();
const browserStorage = {
  getItem: (key) => window.localStorage.getItem(key),
  setItem: (key, value) => window.localStorage.setItem(key, value)
};

export const createCookieNotice = (storage) => {
  let accepted = false;

  try {
    const record = JSON.parse(storage.getItem(STORAGE_KEY));
    accepted = record?.version === RECORD_VERSION && record.accepted === true;
  } catch {
    accepted = false;
  }

  return {
    isAccepted: () => accepted,
    accept: () => {
      if (accepted) return false;

      accepted = true;

      try {
        storage.setItem(STORAGE_KEY, JSON.stringify({
          version: RECORD_VERSION,
          accepted: true
        }));
      } catch {
        // The current page can still honor the visitor's action.
      }

      return true;
    }
  };
};

export const bindCookieNotice = ({ banner, acceptButton, storage }) => {
  if (!banner || initializedBanners.has(banner)) return false;
  if (!acceptButton) return false;

  initializedBanners.add(banner);

  const notice = createCookieNotice(storage);

  if (notice.isAccepted()) return true;

  banner.hidden = false;
  acceptButton.addEventListener('click', () => {
    if (notice.accept()) banner.hidden = true;
  }, { once: true });

  return true;
};

export const initializeCookieNotice = (documentRoot = document) => {
  const banner = documentRoot.querySelector('[data-cookie-notice]');
  if (!banner) return false;

  return bindCookieNotice({
    banner,
    acceptButton: banner.querySelector('[data-cookie-notice-accept]'),
    storage: browserStorage
  });
};
